// extracted by mini-css-extract-plugin
module.exports = {"oldUIoutbanner":"zdphV","banner_img":"_3SjHi","title":"_1zD4V","text":"KKSOH"};